"use client"
import React, { useEffect } from "react"
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion"

const BackgroundComponent = () => {
    // Create motion values for the mouse position
    const mouseX = useMotionValue(0)
    const mouseY = useMotionValue(0)

    // Apply spring to create a slight delay in movement
    const springX = useSpring(mouseX, { stiffness: 50, damping: 20 })
    const springY = useSpring(mouseY, { stiffness: 50, damping: 20 })

    // Calculate transformation based on mouse movement
    const translateX = useTransform(springX, [0, window.innerWidth], [-5, 5])
    const translateY = useTransform(springY, [0, window.innerHeight], [-5, 5])

    // Update mouse coordinates on move
    interface MouseEvent {
        clientX: number
        clientY: number
    }

    const handleMouseMove = (e: MouseEvent) => {
        mouseX.set(e.clientX)
        mouseY.set(e.clientY)
    }

    useEffect(() => {
        // Attach mousemove event listener
        window.addEventListener("mousemove", handleMouseMove)

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener("mousemove", handleMouseMove)
        }
    }, [])

    return (
        <motion.img
            src="/Kerberos-v2.webp"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: 0.5, duration: 1 } }}
            style={{ x: translateX, y: translateY }}
            className="absolute w-[120%] h-auto top-[0px] left-[-300px] z-0"
        />
    )
}

export default BackgroundComponent
